import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useEventListener } from '../useEventListener';
import AttachFileIcon from '@material-ui/icons/AttachFile';

const useStyles = makeStyles((theme) => ({
  input: {
    display: 'none',
  },
  button: {
    color: theme.palette.text.secondary
  }
}));


export default function UploadButton(props) {
  let [selectedFile, setSelectedFile] = useState(false);
  let input = useRef(null);

  const adaptFileEventToValue = delegate => e => {
    let file = e.target.files[0];
    setSelectedFile(file.name);
    console.log("File selected", selectedFile);
    return delegate(file);
  }

  const classes = useStyles();
  return (
    <div className={classes.root}>
      {selectedFile ?
      <Typography gutterBottom color='textSecondary'><AttachFileIcon /> {selectedFile}</Typography>
      : ''}
      <input
        className={classes.input}
        id={`${props.name}-file`}
        name={props.name}
        type="file"
        accept="image/*,.pdf,.doc,.txt"
        ref={input}
        onChange={adaptFileEventToValue(props.onChange)}
        onBlur={adaptFileEventToValue(props.onBlur)}
      />
      <label htmlFor={`${props.name}-file`}>
        <Button classes={{label: classes.button}} startIcon={props.startIcon} variant="outlined" component="span">
          {props.children}
        </Button>
      </label>
    </div>
    );
}
